import { Empty, Skeleton } from "antd";
import React, { useContext, useState } from "react";
import InfoContext from "./reducer";

const columns = [
  {
    title: "#",
    dataIndex: "accountNo",
    width: "10%",
    thClassName: "text-center",
    tdClassName: "text-center",
  },
  {
    title: "ช่องทาง",
    dataIndex: "channel",
    width: "30%",
    thClassName: "text-center",
    tdClassName: "text-left",
  },
  {
    title: "ชื่อบัญชี",
    dataIndex: "accountName",
    width: "60%",
    thClassName: "text-center",
    tdClassName: "text-left",
    render: (text) => (
      <div style={{ wordBreak: "break-word" }}>
        {text}
      </div>
    ),
  },
];

const getSocialRows = (socials, socialType, socialName) =>
  socials
    .filter((item) => item?.social_type?.toLowerCase() === socialType)
    .map((item) => item?.account_name)
    .filter(Boolean)
    .map((accountName) => ({
      channel: socialName,
      accountName,
    }));

const SocialTable = ({ dataSource }) => {
  if (dataSource.length === 0) return <Empty className="mt-2" />;

  return (
    <table
      className="table table-sm table-bordered m-0 w-100"
      style={{ tableLayout: "fixed" }}
    >
      <colgroup>
        {columns.map((column, index) => (
          <col key={index} style={{ width: column.width }} />
        ))}
      </colgroup>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th
              className={`font-weight-normal px-1 py-1 ${column.thClassName}`}
              key={index}
            >
              {column.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {dataSource.map((item, index) => (
          <tr className="bg-transparent" key={index}>
            {columns.map((column, columnIndex) => (
              <td
                className={`px-1 py-1 ${column.tdClassName}`}
                key={columnIndex}
              >
                {column.render
                  ? column.render(item[column.dataIndex])
                  : item[column.dataIndex]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const SocialCard = () => {
  const { state } = useContext(InfoContext);
  const [isExpanded, setIsExpanded] = useState(false);

  if (state.loading) return <Skeleton active />;

  const socials = state.socials || [];
  const dataSource = [
    ...getSocialRows(socials, "tiktok", "TikTok"),
    ...getSocialRows(socials, "shopee", "Shopee"),
  ].map((item, index) => ({
    ...item,
    accountNo: index + 1,
  }));

  return (
    <>
    <br></br>
      <div
        className="mb-2 px-2 py-1"
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
          background: "#e3e3e3",
          cursor: "pointer",
          userSelect: "none",
          width: "100%",
        }}
      >
        <strong>บัญชี TikTok/Shopee</strong>
        <strong className="ml-2">{isExpanded ? "▼" : "▶"}</strong>
      </div>
      {isExpanded && (
        <div style={{ color: "#000", fontWeight: "normal" }}>
          <SocialTable dataSource={dataSource} />
        </div>
      )}
    </>
  );
};

export default SocialCard;
